import { useTranslation } from "react-i18next"

import NotFoundSVG from "./assets/not-found.svg?react"

export const NotFound = () => {
    const { t } = useTranslation("gift_card")

    return (
        <div className="h-full flex flex-col justify-center items-center ">
            <NotFoundSVG />
            <div className="mb-4 font-bold text-[1.75rem] leading-9.5">
                {t("niki.gift_card.not_found.title")}
            </div>
            <div className="text-[#373737]">
                {t("niki.gift_card.not_found.content")}
            </div>
        </div>
    )
}
